import Title from "../components/TheTitle.vue";
import { searchCouponHistory } from "../api";
import { Validation } from "../utils/validation";
import { FormatDate } from "../utils/formatDate";
import { Authorize } from "../utils/authorize";
export default {
    name: "couponTransactionHistory",
    data() {
        return {
            infoPage: 1,
            pageSize: 100,
            tableInfo: [],
            form: {
                history_type: "",
                customer_id: "",
                discount_min: "",
                discount_max: "",
                discount_unit: "",
                coupon_code: "",
                history_date_from: "",
                history_date_to: "",
                grant_brandStore: "",
                use_brandStore: "",
                expiration_date_from: "",
                expiration_date_to: "",
                billing_amount_min: "",
                billing_amount_max: "",
                discount_amount_min: "",
                discount_amount_max: "",
                payment_amount_min: "",
                payment_amount_max: "",
            },
        };
    },
    components: {
        Title,
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    watch: {
        "form.discount_unit": async function (newVal, oldVal) {
            if (!oldVal)
                return;
            this.form.discount_min = "";
            this.form.discount_max = "";
        },
    },
    methods: {
        setInfoPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.infoTotalPages)
                p = this.infoTotalPages;
            this.infoPage = p;
        },
        formatDate(value) {
            return FormatDate.withoutTime(value);
        },
        exportCsv() {
            if (!this.tableInfo.length) {
                this.$store.commit("setMessages", ["出力対象のデータが存在しません。"]);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            // 1) ヘッダを作成
            const header = [
                "付与/利用",
                "顧客ID",
                "クーポン種別",
                "クーポンコード",
                "付与/利用日",
                "付与店舗",
                "利用店舗",
                "クーポン有効期限",
                "請求金額",
                "割引額",
                "支払額",
            ];
            // 2) tableInfo から値を取得（空文字や null は空文字に）
            const rows = this.tableInfo.map((t) => [
                t.history_type === 0 ? "付与" : "利用",
                t.crm_customer_id,
                t.discount + (t.discount_unit === 0 ? "円引き" : "%割引"),
                this.formatDate(t.history_date),
                t.grant_store,
                t.use_store,
                this.formatDate(t.expiration_date),
                t.billing_amount ? "￥" + t.billing_amount : null,
                t.discount_amount ? "￥" + t.discount_amount : null,
                t.payment_amount ? "￥" + t.payment_amount : null,
            ]);
            // 3) CSV を作る
            const escapeCsv = (value) => {
                if (value == null)
                    return "";
                const v = String(value);
                return v;
            };
            const lines = [];
            lines.push(header.map(escapeCsv).join(","));
            for (const r of rows) {
                lines.push(r.map(escapeCsv).join(","));
            }
            let csvContent = lines.join("\r\n");
            // 4) Excel で文字化けしにくくするために UTF-8 BOM を付与（不要なら削除）
            const bom = "\uFEFF";
            const blob = new Blob([bom + csvContent], {
                type: "text/csv;charset=utf-8;",
            });
            // 5) ダウンロード処理
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            // ファイル名（任意）
            a.download = "クーポン取引履歴_検索結果.csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
        onClear() {
            this.form = {
                history_type: "",
                customer_id: "",
                discount_min: "",
                discount_max: "",
                discount_unit: "",
                coupon_code: "",
                history_date_from: "",
                history_date_to: "",
                grant_brandStore: "",
                use_brandStore: "",
                expiration_date_from: "",
                expiration_date_to: "",
                billing_amount_min: "",
                billing_amount_max: "",
                discount_amount_min: "",
                discount_amount_max: "",
                payment_amount_min: "",
                payment_amount_max: "",
            };
        },
        async onSearch() {
            const params = {
                history_type: (this.form.history_type || null),
                crm_customer_id: (this.form.customer_id || null),
                discount_min: (this.form.discount_min || null),
                discount_max: (this.form.discount_max || null),
                discount_unit: (this.form.discount_unit || null),
                coupon_code: (this.form.coupon_code || null),
                history_date_from: (this.form.history_date_from || null),
                history_date_to: (this.form.history_date_to || null),
                grant_brandStore: (this.form.grant_brandStore || null),
                use_brandStore: (this.form.use_brandStore || null),
                expiration_date_from: (this.form.expiration_date_from || null),
                expiration_date_to: (this.form.expiration_date_to || null),
                billing_amount_min: (this.form.billing_amount_min || null),
                billing_amount_max: (this.form.billing_amount_max || null),
                discount_amount_min: (this.form.discount_amount_min || null),
                discount_amount_max: (this.form.discount_amount_max || null),
                payment_amount_min: (this.form.payment_amount_min || null),
                payment_amount_max: (this.form.payment_amount_max || null),
            };
            const errorMessage = this.validate(params);
            if (errorMessage) {
                this.$store.commit("setMessages", errorMessage);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            const response = await searchCouponHistory(null, params.history_type, params.crm_customer_id, params.discount_min, params.discount_max, params.discount_unit, params.coupon_code, params.history_date_from, params.history_date_to, params.grant_brandStore, params.use_brandStore, params.expiration_date_from, params.expiration_date_to, params.billing_amount_min, params.billing_amount_max, params.discount_amount_min, params.discount_amount_max, params.payment_amount_min, params.payment_amount_max);
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.tableInfo = response.data.results;
                this.infoPage = 1;
            }
        },
        validate(params) {
            // エラーメッセージを格納する配列
            const errors = [];
            // 桁数チェック
            errors.push(...Validation.digitsMax({
                key: "顧客ID",
                value: params.crm_customer_id,
            }, 20));
            errors.push(...Validation.digitsMax({
                key: "クーポン種別min",
                value: params.discount_min,
            }, 6));
            errors.push(...Validation.digitsMax({
                key: "クーポン種別max",
                value: params.discount_max,
            }, 6));
            errors.push(...Validation.digitsMax({
                key: "クーポンコード",
                value: params.coupon_code,
            }, 9));
            errors.push(...Validation.digitsMax({
                key: "付与店舗（ブランド）",
                value: params.grant_brandStore,
            }, 80));
            errors.push(...Validation.digitsMax({
                key: "利用店舗（ブランド）",
                value: params.use_brandStore,
            }, 80));
            errors.push(...Validation.digitsMax({
                key: "請求金額min",
                value: params.billing_amount_min,
            }, 10));
            errors.push(...Validation.digitsMax({
                key: "請求金額max",
                value: params.billing_amount_max,
            }, 10));
            errors.push(...Validation.digitsMax({
                key: "割引額min",
                value: params.discount_amount_min,
            }, 10));
            errors.push(...Validation.digitsMax({
                key: "割引額max",
                value: params.discount_amount_max,
            }, 10));
            errors.push(...Validation.digitsMax({
                key: "支払額min",
                value: params.payment_amount_min,
            }, 10));
            errors.push(...Validation.digitsMax({
                key: "支払額max",
                value: params.payment_amount_max,
            }, 10));
            // 属性チェック
            if (params.crm_customer_id) {
                errors.push(...Validation.isInteger({
                    key: "顧客ID",
                    value: params.crm_customer_id,
                }));
            }
            if (params.discount_min) {
                errors.push(...Validation.isInteger({
                    key: "クーポン種別min",
                    value: params.discount_min,
                }));
            }
            if (params.discount_max) {
                errors.push(...Validation.isInteger({
                    key: "クーポン種別max",
                    value: params.discount_max,
                }));
            }
            if (params.coupon_code) {
                errors.push(...Validation.isNotContainSymbols({
                    key: "クーポンコード",
                    value: params.coupon_code,
                }));
            }
            if (params.billing_amount_min) {
                errors.push(...Validation.isInteger({
                    key: "請求金額min",
                    value: params.billing_amount_min,
                }));
            }
            if (params.billing_amount_max) {
                errors.push(...Validation.isInteger({
                    key: "請求金額max",
                    value: params.billing_amount_max,
                }));
            }
            if (params.discount_amount_min) {
                errors.push(...Validation.isInteger({
                    key: "割引額min",
                    value: params.discount_amount_min,
                }));
            }
            if (params.discount_amount_min) {
                errors.push(...Validation.isInteger({
                    key: "割引額max",
                    value: params.discount_amount_min,
                }));
            }
            if (params.payment_amount_min) {
                errors.push(...Validation.isInteger({
                    key: "支払額min",
                    value: params.payment_amount_min,
                }));
            }
            if (params.payment_amount_max) {
                errors.push(...Validation.isInteger({
                    key: "支払額max",
                    value: params.payment_amount_max,
                }));
            }
            // 相関チェック
            if (Number(params.discount_unit) === 1 &&
                (Number(params.discount_min) > 100 || Number(params.discount_max) > 100)) {
                errors.push("割引単位に%を選択時はクーポン種別に100以下の値を選択してください。");
            }
            if (params.discount_min &&
                params.discount_max &&
                Number(params.discount_min) >= Number(params.discount_max)) {
                errors.push("クーポン種別の下限値と上限値は、下限値が上限値より小さくなるように入力してください。");
            }
            if (params.history_date_from &&
                params.history_date_to &&
                params.history_date_from > params.history_date_to) {
                errors.push("付与/利用日のFromとToは、FromがToより小さくなるように入力してください。");
            }
            if (params.expiration_date_from &&
                params.expiration_date_to &&
                params.expiration_date_from > params.expiration_date_to) {
                errors.push("クーポン有効期限のFromとToは、FromがToより小さくなるように入力してください。");
            }
            if (params.billing_amount_min &&
                params.billing_amount_max &&
                Number(params.billing_amount_min) >= Number(params.billing_amount_max)) {
                errors.push("請求額の下限値と上限値は、下限値が上限値より小さくなるように入力してください。");
            }
            if (params.discount_amount_min &&
                params.discount_amount_max &&
                Number(params.discount_amount_min) >= Number(params.discount_amount_max)) {
                errors.push("割引額の下限値と上限値は、下限値が上限値より小さくなるように入力してください。");
            }
            if (params.payment_amount_min &&
                params.payment_amount_max &&
                Number(params.payment_amount_min) >= Number(params.payment_amount_max)) {
                errors.push("支払額の下限値と上限値は、下限値が上限値より小さくなるように入力してください。");
            }
            if (errors.length > 0) {
                return errors;
            }
            return "";
        },
    },
    async mounted() {
        await Authorize.isExpired(this);
    },
};
